import { useContext } from "react";
import { FirebaseAuthContext } from "src/contexts/FirebaseAuthContext";

const useAuth = () => useContext(FirebaseAuthContext);

export default useAuth;
